import { Box, Select as GrommetSelect } from 'grommet';
import styled from 'styled-components';
import { motifs } from '../../themes/default.theme';

export const UploadButton = styled.button`
  font-weight: 700;
  font-size: 14px;
  background-color: #65a100;
  color: #ffffff;
  border-radius: 3px;
  border: 1px solid #65a100;
  padding-top: 7px;
  padding-bottom: 6px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: 15px;
  margin-top: 15px;
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
    background: #e0e0e0;
    color: #979797;
    border: none;
  }
`;

export const StyledDocumentsBox = styled(Box)`
  box-shadow: 0 2px 4px 0 rgba(1, 83, 142, 0.2);
  background-color: #ffffff;
`;

export const IconContainer = styled.div`
  width: 22px;
`;
export const SelectWrapper = styled.div`
  margin-top: 15px;
  button {
    border-color: ${motifs.lightBorder};
    border-radius: 3px;
    & > div {
      border-radius: 3px;
    }
  }
`;

export const Select = styled(GrommetSelect)`
  font-weight: normal;
`;
